const doc = [({"se":({"js":({"components":({"surveys":({"surveys":({"copy_step_button":({})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;